module.exports = __webpack_public_path__ + "img/wallet_04_create.517c79f5.png";